import styled from 'styled-components';

const Heading = styled.h1`
  font-size: 72px;
  font-weight: 400;
`;

export default Heading;
